module.exports = __webpack_public_path__ + "img/dropdown-arrow.949c1d80.svg";